module.exports = __webpack_public_path__ + "img/e-Card-Greetings-en.547b650.png";